export const SELL_TRACTOR_SURVEY_FEATURE_VERSION = 1;
export const OWN_TRACTOR_SURVEY_FEATURE_VERSION = 1;

export const ANONYMOUS_USER_ID = 'anonymous';

export const TEMP_DATA_KEYS = {
  SELL_TRACTOR_SURVEY: 'SELL_TRACTOR_SURVEY',
  OWN_TRACTOR_SURVEY: 'OWN_TRACTOR_SURVEY',
};
